import "./Globals/Declarations/GlobalVariables";
import "./Globals/Declarations/GlobalExtensions";
import "./Globals/Declarations/GlobalStyles";
import "moment/locale/es";
import "moment/locale/fr";

import { render } from "react-dom";

import { AIScribeStore } from "./AIScribe/Stores/AIScribeStore";
import { MyleHelper } from "./Common/Helpers/MyleHelper";
import { OverlayStore } from "./Common/Stores/OverlayStore";
import { CacheStore } from "./Globals/Stores/CacheStore";
import { SessionStore } from "./Globals/Stores/SessionStore";
import { MyleApp } from "./Myle/Apps/MyleApp";
import { NoteApp } from "./Myle/Apps/NoteApp";
import { PAListApp } from "./Myle/Apps/PAListApp";
import { PasswordResetApp } from "./Myle/Apps/PasswordResetApp";
import { SecondScreenApp } from "./Myle/Apps/SecondScreenApp";
import { VigilanceViewerApp } from "./Myle/Apps/VigilanceViewerApp";
import { PatientStore } from "./Patient/Stores/PatientStore";
import { SettingsStore } from "./Settings/Stores/SettingsStore";
import { initDomains } from "./setupDomains";

window.CurrentDevice = {
    Android: function() {
        return navigator.userAgent.match(/Android/i)?.any();
    },
    BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i)?.any();
    },
    iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i)?.any();
    },
    Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i)?.any();
    },
    Windows: function() {
        return navigator.userAgent.match(/IEMobile/i)?.any() || navigator.userAgent.match(/WPDesktop/i)?.any();
    },
    Any: function() {
        return (CurrentDevice.Android() || CurrentDevice.BlackBerry() || CurrentDevice.iOS() || CurrentDevice.Opera() || CurrentDevice.Windows());
    }
};

initDomains();

window.baseURI = process.env.REACT_APP_BASE_URL?.toLowerCase() ?? window.location.host.toLowerCase();
window.currentLang = navigator.language ?? "en";
window.rootPath = document.querySelector("base").getAttribute("href").replace(/\/$/g, "");

const parsedQueryString = MyleHelper.parseQueryString();
const msaIdKey = "msa_id";
const localeKey = "locale";
const apiTokenKey = "token";
const encounterIdKey = "encounterid";

// Keep msa ID in session to support page refresh
const msaIdQueryValue = parsedQueryString[msaIdKey];
if (msaIdQueryValue)
    sessionStorage.setItem(msaIdKey, msaIdQueryValue);
window.msa_id = sessionStorage.getItem(msaIdKey);

// Start app according to path
if (location.pathname.toLowerCase().contains("/handnote")) {
    $("head").append('<link rel="stylesheet" href="./compiled/handnotebase.css">');
    $("head").append('<script src="./compiled/base-note.js">');
    const encounterId = parsedQueryString[encounterIdKey] || "";
    const noteApp = new NoteApp();
    noteApp.Load(
        "root",
        rootPath,
        window.opener.cacheStore,
        window.opener.sessionStore,
        encounterId
    );
}
else if (location.pathname.toLowerCase().contains("/palist")) {
    const paListApp = new PAListApp();
    paListApp.Start(
        rootPath,
        "root",
        window.opener.cacheStore,
        window.opener.sessionStore,
        window.opener.calendarStore,
        window.opener.apiSettings,
        window.opener.settingsStore,
        window.opener.patientStore
    );
}
else if (location.pathname.toLowerCase().contains("/passwordreset")) {
    const locale = parsedQueryString[localeKey] || "en";
    const token = parsedQueryString[apiTokenKey];
    const passwordResetApp = new PasswordResetApp();
    passwordResetApp.start(
        "root",
        token,
        locale,
        rootPath,
        window.baseURI + rootPath
    );
}
else if (location.pathname.toLowerCase().contains("/2ndscreen")) {
    if (!window.opener) {
        window.location.href = window.location.origin;
    }
    window.rootPath = window.opener.rootPath;
    window.apiSettings = window.opener.apiSettings;
    window.cacheStore = CacheStore.createSingletonFrom(window.opener.cacheStore);
    window.sessionStore = SessionStore.createSingletonFrom(window.opener.sessionStore);
    window.settingsStore = SettingsStore.createSingletonFrom(window.opener.settingsStore);
    window.patientStore = PatientStore.createSingleton();
    window.overlayStore = OverlayStore.createSingleton();
    window.aiScribeStore = AIScribeStore.createSingleton();
    render(<SecondScreenApp />, document.getElementById("root"));
}
else if (location.pathname.toLowerCase().contains("/vigilance")) {
    render(<VigilanceViewerApp />, document.getElementById("root"));
}
else {
    const myleApp = new MyleApp();
    myleApp.Start("root", rootPath);
}
